import React from 'react';

/**
 * AuroraBackground - Animated aurora gradient orbs for atmospheric background effects
 *
 * Usage:
 * <AuroraBackground />
 *
 * This component adds three animated gradient orbs (pink, blue, cyan) that float and pulse
 * in the background to create an atmospheric, tech-forward aesthetic.
 */
const AuroraBackground = () => {
  return (
    <>
      <div className="aurora aurora-pink" />
      <div className="aurora aurora-blue" />
      <div className="aurora aurora-cyan" />
    </>
  );
};

export default AuroraBackground;
